.overlay {
  position: fixed;
  inset: 0;
  background: rgba(4, 13, 24, 0.88);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--sp-4);
  z-index: 400;
}

.modal {
  width: 100%;
  max-width: 360px;
  background: var(--color-surface);
  border: 1px solid var(--color-border-med);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-strong);
  padding: var(--sp-6);
  display: flex;
  flex-direction: column;
  gap: var(--sp-3);
}

.title {
  font-family: var(--font-mono);
  font-size: 16px;
  font-weight: 700;
  color: var(--color-text);
}

.body {
  font-size: 13px;
  color: var(--color-text-muted);
  line-height: 1.6;
}

.body strong {
  color: var(--color-text);
}

.actions {
  display: flex;
  gap: var(--sp-3);
  margin-top: var(--sp-2);
}

.stayBtn {
  flex: 1;
  font-family: var(--font-mono);
  font-size: 12px;
  font-weight: 600;
  padding: var(--sp-3) var(--sp-4);
  border-radius: var(--radius-md);
  background: linear-gradient(135deg, rgba(56,189,248,0.15) 0%, rgba(13,148,136,0.15) 100%);
  border: 1px solid rgba(56, 189, 248, 0.3);
  color: var(--color-sky);
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
}

.stayBtn:hover {
  background: linear-gradient(135deg, rgba(56,189,248,0.22) 0%, rgba(13,148,136,0.22) 100%);
  border-color: rgba(56, 189, 248, 0.5);
}

.signOutBtn {
  font-family: var(--font-mono);
  font-size: 12px;
  padding: var(--sp-3) var(--sp-4);
  border-radius: var(--radius-md);
  background: transparent;
  border: 1px solid var(--color-border);
  color: var(--color-text-muted);
  cursor: pointer;
  transition: border-color 0.15s, color 0.15s;
}

.signOutBtn:hover {
  border-color: var(--color-border-med);
  color: var(--color-text);
}
